import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Profile from "../../components/Profile";
import AdmissionForm from "./AdmissionForm";
import SubjectSelection from "./SubjectSelection";
import DocumentUploadPage from "./DocumentUploadPage";
import PaymentPage from "./PaymentPage";
import StudentDashboard from "./StudentDashboard";
import { apiBlob } from "../../utils/api";
import { LanguageToggle } from "../../i18n/LanguageContext";

const StudentLayout = () => {
  const [selected, setSelected] = useState("dashboard");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const student = JSON.parse(localStorage.getItem("student") || "{}");

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const downloadCertificate = async () => {
    try {
      const blob = await apiBlob("/api/student/certificate");
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `bonafide_${student.applyId}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Error downloading certificate");
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div className="flex h-screen overflow-hidden">
      <div
        className={`fixed z-20 top-0 left-0 h-full bg-gray-900 text-white w-64 p-4 transition-transform transform md:translate-x-0 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:static md:block`}
      >
        <Sidebar
          onSelect={(s) => { setSelected(s); setIsSidebarOpen(false); }}
          handleLogout={handleLogout}
          student={student}
          selected={selected}
        />
      </div>

      <div className="flex-1 flex flex-col overflow-y-auto">
        <div className="bg-white border-b px-4 py-2 flex items-center justify-between shadow-sm">
          <button className="md:hidden text-gray-700" onClick={toggleSidebar}>☰</button>
          <span className="md:hidden text-sm font-semibold text-gray-700">Student Portal</span>
          <div className="md:ml-auto flex items-center gap-3">
            <LanguageToggle />
            <button
              onClick={handleLogout}
              className="text-xs px-3 py-1 rounded bg-red-50 text-red-600 hover:bg-red-100 border border-red-200"
            >
              Logout
            </button>
          </div>
        </div>

        <main className="p-4">
          {selected === "dashboard" && (
            <StudentDashboard
              onNavigate={(s) => setSelected(s)}
            />
          )}
          {selected === "profile" && <Profile />}
          {selected === "admission-form" && <AdmissionForm />}
          {selected === "subject-selection" && <SubjectSelection />}
          {selected === "documents" && <DocumentUploadPage />}
          {selected === "payment" && <PaymentPage />}

          {selected === "certificate" && (
            <div className="max-w-xl mx-auto bg-white p-6 rounded shadow">
              <h2 className="text-lg font-semibold mb-2">
                Download Bonafide Certificate
              </h2>
              <p className="text-sm text-gray-600 mb-4">
                You can download your bonafide certificate below.
              </p>
              <button
                onClick={downloadCertificate}
                className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded transition"
              >
                Download PDF
              </button>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default StudentLayout;
